import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingWarnDanger } from '../constants/constants';

@Pipe({ name: 'colorMappingWarnDanger' })
export class ColorMappingWarnDangerPipe implements PipeTransform {
  transform(value: number) {
    return colorMappingWarnDanger(value);
  }
}
